import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class StoreService {
  // Subject store
  public static _subjects: { [ID: string]: BehaviorSubject<any> } = {};

  // Set a new subject in the store with a given ID as key
  // and return an observable attached to it
  static create(ID: string, data?: any): Observable<any> {
    this._get(ID);
    if (data) {
      this.update(ID, data);
    }
    return this.get(ID);
  }

  // Get an observable from the store subject
  static get(ID: string): Observable<any> {
    return new Observable((fn) => this._get(ID).subscribe(fn));
  }

  // Update a subject from the store
  static update(ID: string, data: any) {
    this._get(ID).next(data);
  }

  // Merge subject data with data provided
  // If you want to pass some new filters without overwriting the previous ones you can use the third argument(appendExtraFilters)
  static merge(ID: string, data: any, appendExtraFilters?: any) {
    const subject = this._get(ID);
    const queryParameters = Object.assign({}, subject.getValue(), data);
    if (appendExtraFilters) {
      if (queryParameters.filters) {
        Object.keys(appendExtraFilters).forEach((key) => queryParameters.filters.set(key, appendExtraFilters[key]));
      } else {
        queryParameters.filters = appendExtraFilters;
      }
    }
    subject.next(queryParameters);
  }

  static remove(ID: string): boolean {
    if (this._subjects[ID]) {
      this._subjects[ID].complete();
      return delete this._subjects[ID];
    }
    return false;
  }

  // Check if store contains a subject with the provided ID
  static contains(ID: string): boolean {
    return !!this._subjects[ID];
  }

  // Private method to get a subject or create if doesn't exists
  static _get(ID: string): BehaviorSubject<any> {
    if (!this._subjects[ID]) {
      this._subjects[ID] = new BehaviorSubject(null);
    }
    return this._subjects[ID];
  }
}
